import {type CheckoutCarRentalServiceOption, ServiceType} from "../../../domain/types";
import * as React from 'react';
import {
  Collapsible,
  CollapsibleRoot, CollapsibleTrigger,
  ListItem,
  RadioGroup,
  tk,
} from '@sunwebgroup/ui-components';
import {useIntl} from '@/intl';
import {useService} from '@/scopes/checkout/domain/hooks';
import {EditFormContainerView, getIfCarIsSelected} from './EditFormContainerView';
import {CarContentView} from './CarContentView';
import {carIsBeingEdited, useCarRentalServiceStore} from './store';
import {styled} from 'styled-components';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { createCarEvent } from '../../../domain/analytics';
import { ShowMore } from '../../../../common/components/ShowMore';

function ExtraCarOption(option: CheckoutCarRentalServiceOption) {
  const {value} = option;

  const isCarBeingEdited = useCarRentalServiceStore(carIsBeingEdited(value))

  return (
    <CarItemOtion open={isCarBeingEdited}>
      <ListItem.Root>
        <ListItemControl>
          <RadioGroup.Item value={value} />
        </ListItemControl>
        <ListItem.Content>
          <CarContentView {...option} />
        </ListItem.Content>
      </ListItem.Root>
      <Collapsible>
        <EditFormContainerView carValue={value}/>
      </Collapsible>
    </CarItemOtion>
  )
}
const CarItemOtion = styled(CollapsibleRoot)`
  margin-bottom: ${tk('spacing_sm')};
`;

export function CarsListView() {
  const intl = useIntl();
  const {service} = useService(ServiceType.CarRental);
  const { sendEvent } = useAnalytics();

  const handleClickViewMoreButton = (value: boolean) => {
  if (!service) return;
  const { carLists } = service;
    sendEvent(
      createCarEvent({
        result: value ? 'show more' : 'show less',
        type: `car list ${carLists ? carLists.length + 1 : 1}`,
        description: 'Open component',
        element: 'collapse',
      })
    )
  };

  if (!service) return null;

  const {options} = service;

  return (
    <RadioGroup.Root>
      <StyledShowMore
        openLabel={intl.formatMessage({id: 'checkout_steps_ancillaries_car_rental_show_more'})}
        closeLabel={intl.formatMessage({id: 'checkout_steps_ancillaries_car_rental_show_less'})}
        onOpen={handleClickViewMoreButton}
        buttonTriggerHierarchy="secondary"
      >
        {Object.values(options ?? {})
          .filter(({value}) => !getIfCarIsSelected(value, service))
          .map((option) => (
            <ExtraCarOption key={option.value} {...option} />
          ))}
      </StyledShowMore>
    </RadioGroup.Root>
  );
}

export const ListItemControl = styled(ListItem.Control)`
  align-self: flex-start;
`;

export const StyledShowMore = styled(ShowMore)`
  ${CollapsibleRoot} {
    display: flex;
    flex-direction: column;
     margin-left: auto;
     margin-right: auto;
     max-width: fit-content;
  }
  ${CollapsibleTrigger} {
     margin-left: auto;
     margin-right: auto;
     max-width: fit-content;
   }
`;
